import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomerService } from '../services/customer.service';
import { Customer } from '../models/customer.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'customer',
  templateUrl: '../views/admin/customer.html',
  providers: [CustomerService]
})
export class CustomerComponent{
  public title: string;
  public customers: Customer[];
  public submitCustomerModel: Customer;
  public message: any;
  public mode: string;
  public wait:boolean;
  public customerPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private customerService: CustomerService,
    public sharedVariables: VariableService
  )
  {

      this.title = null;
      this.mode = "submit-add";
      this.submitCustomerModel = new Customer(0,'','','','','','','','');
      this.wait = true;
      this.customerPrivilege = null;

  }

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.customerPrivilege == 1){
                                    this.getAllCustomers();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllCustomers()
  {
    this.customerService.getCustomers().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.customers = result.data;
          console.log(this.customers);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveCustomer();
    }else{
      this.updateCustomer();
    }
    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllCustomers();
                      this.submitCustomerModel = new Customer(0,'','','','','','','','');
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  saveCustomer()
  {
    this.customerService.addCustomer(this.submitCustomerModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  validSession()
  {
    console.log(GLOBAL.sessionInfo.login);
    if(GLOBAL.sessionInfo.login)
      return true;
    else
      return false;
  }

  editCustomer(pCustomer: Customer)
  {
    this.mode = "submit-update";
    this.submitCustomerModel = Object.assign({}, pCustomer);

    console.log("Checkout objects");
    console.log("mode",this.mode);
  }

  updateCustomer()
  {
      let id = this.submitCustomerModel.ID;
      console.log("objeto update ",this.submitCustomerModel);
      this.customerService.updateCustomer(id,this.submitCustomerModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }
  cleanObject()
  {
    this.submitCustomerModel = new Customer(0,'','','','','','','','');
    this.mode = 'submit-add';
  }
  deleteCustomer(id: number)
  {
    this.customerService.deleteCustomer(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllCustomers();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.customerPrivilege = response.data[0].Customer;
            console.log("Privilegios del usuario",this.customerPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/customer.component.ts